import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Mark, Arrow } from "./Icons";
import { profile } from "./content";

export default function SiteHeader() {
  return (
    <header className="site-header wrap">
      <Link to="/" className="site-brand" aria-label="Hunter Grey, home">
        <Mark />
        <span>Hunter Grey</span>
      </Link>
      <nav className="site-nav" aria-label="Main navigation">
        <NavLink exact to="/" activeClassName="is-current">
          Home
        </NavLink>
        <NavLink to="/projects" activeClassName="is-current">
          Projects
        </NavLink>
        <NavLink to="/about" activeClassName="is-current">
          About
        </NavLink>
        <NavLink to="/contact" activeClassName="is-current">
          Contact
        </NavLink>
      </nav>
      <a
        className="portal-link"
        href={profile.portal}
        target="_blank"
        rel="noopener noreferrer"
      >
        Login <Arrow diagonal />
      </a>
    </header>
  );
}
